import client from './apiClient';

/**
 * @param {string} publicId The public id of a resource
 * @param {string} environment The environment name where to find the resource
 * @returns {Promise<import('./types').PublicInfo>}
 */
function get(publicId, environment) {
  return client(`publicinfo?publicId=${publicId}&environment=${environment}`);
}

export { get };
